<template>
  <v-dialog max-width="1100" width="95%" v-model="dialog" persistent scrollable>
    <v-card>
      <v-app-bar color="primary" flat dense>
        <v-toolbar-title class="text-h6 white--text pl-0">
          Nueva nota crédito de documento equivalente
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" icon @click="closeModal()" :title="$t('Cancel')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-text class="nota-credito">
        <p class="nota-credito__sub">
          Elige por qué se hace la nota y añade lo que se devuelve o se descuenta.
        </p>
        <ValidationObserver v-slot="{ invalid, errors }" ref="form">
          <section class="nota-credito__seccion">
            <header class="nota-credito__cabecera">Datos de la nota</header>
            <v-row no-gutters class="pa-3">
              <v-col class="px-1 input-form-credit_note_date" cols="12" md="4">
                <ng-date
                  v-model="form.credit_note_date"
                  label="Fecha de la nota *"
                  :rules="rules['credit_note_date']"
                ></ng-date>
              </v-col>
              <v-col class="px-1" cols="12" md="4">
                <v-text-field
                  :value="$filters.name(form.invoice)"
                  label="Factura *"
                  outlined
                  dense
                  readonly
                  hide-details="auto"
                  prepend-inner-icon="mdi-receipt-text-outline"
                  hint="La orden desde la que se hace la devolución"
                ></v-text-field>
              </v-col>
              <v-col
                class="px-1 input-form-credit_note_discrepancy_responses"
                cols="12"
                md="4"
              >
                <ng-select
                  v-model="form.credit_note_discrepancy_responses"
                  label="Motivo *"
                  :rules="rules['credit_note_discrepancy_responses']"
                  url="api/v1/lists/credit-note-discrepancy-responses"
                ></ng-select>
                <a href="#" class="nota-credito__ayuda" @click.prevent="ayudaMotivos = true">
                  <v-icon x-small color="primary">mdi-help-circle-outline</v-icon>
                  ¿Qué significa cada motivo?
                </a>
              </v-col>
              <v-col class="px-1 input-form-observations" cols="12" md="12">
                <ng-textarea
                  v-model="form.observations"
                  label="Observaciones *"
                  :rules="rules['observations']"
                ></ng-textarea>
              </v-col>
            </v-row>
          </section>

          <section class="nota-credito__seccion">
            <header class="nota-credito__cabecera">Detalle</header>
            <div v-if="!$store.getters.mobile">
              <FormDetailsDesktopView
                :items="form.details"
                :form="form"
                :disabled="false"
                @add:item="addItemToDetails"
                @save:item="saveRowItem"
                :products-invoice="productsAvailables"
              ></FormDetailsDesktopView>
            </div>
            <div v-else>
              <FormDetailsMobileView
                :items="form.details"
                :form="form"
                @add:item="addItemToDetails"
                @save:item="saveRowItem"
                :products-invoice="productsAvailables"
                :disabled="false"
              ></FormDetailsMobileView>
            </div>
            <div class="nota-credito__total">
              <span>Total de la nota</span>
              <strong>{{ $filters.currency(totalNota, 0) }}</strong>
            </div>
          </section>

          <div class="nota-credito__pie">
            <v-btn color="secondary" outlined small @click="closeModal()">
              <v-icon small left>mdi-close</v-icon>{{ $t("Cancel") }}
            </v-btn>
            <v-btn
              color="primary"
              small
              :disabled="invalid || !form.details || form.details.length == 0"
              @click="executeCreate()"
            >
              <v-icon small left>mdi-content-save</v-icon>{{ $t("save") }}
            </v-btn>
          </div>
          <default-errors :errors="errors"></default-errors>
        </ValidationObserver>
      </v-card-text>

      <v-dialog v-model="ayudaMotivos" max-width="640">
        <v-card>
          <v-card-title class="text-h6">Motivos de una nota crédito</v-card-title>
          <v-card-text>
            <ul class="nota-credito__motivos">
              <li><b>Ajuste de precio:</b> cuando deseas modificar el valor de un producto o servicio.</li>
              <li><b>Anulación de factura electrónica:</b> por errores en la factura, cambios en los términos acordados o situaciones especiales; recuerda reversar completamente el inventario de todos los productos.</li>
              <li><b>Devolución parcial de los bienes y/o no aceptación parcial del servicio:</b> cuando se devuelve solo una parte de los bienes adquiridos o se rechaza parcialmente un servicio.</li>
              <li><b>Rebaja o descuento parcial o total:</b> reducción del precio, de manera parcial o total.</li>
              <li><b>Otros:</b> algún motivo diferente a los de este listado.</li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="ayudaMotivos = false">Entendido</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>
<style scoped>
.nota-credito__sub {
  margin: 12px 0 14px;
  color: #5f6368;
}
.nota-credito__seccion {
  margin-bottom: 16px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  overflow: hidden;
}
.nota-credito__cabecera {
  padding: 8px 14px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #5f6368;
  background: #f5f6f8;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.nota-credito__ayuda {
  display: inline-block;
  margin: 4px 0 0 4px;
  font-size: 12px;
  text-decoration: none;
}
.nota-credito__total {
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  gap: 16px;
  margin: 10px 14px 14px;
  padding: 8px 14px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  background: #f5f6f8;
}
.nota-credito__total strong {
  font-size: 18px;
}
.nota-credito__pie {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.nota-credito__motivos li {
  margin-bottom: 8px;
}
</style>
<script>
import MixinForm from "./MixinForm";
import FormDetailsDesktopView from "./FormDetailsDesktopView.vue";
import FormDetailsMobileView from "./FormDetailsMobileView.vue";

export default {
  mixins: [MixinForm],
  components: { FormDetailsDesktopView, FormDetailsMobileView },
  data() {
    return {
      dialog: false,
      order: null,
      invoice: null,
      form: {},
      item: null,
      rules: {},
      // Orden cobrada con factura electrónica: nota crédito normal; si no, la de documento equivalente.
      electronica: false,
      ayudaMotivos: false,
    };
  },
  computed: {
    urlSave() {
      return this.electronica ? "api/v1/credit-note-pos" : "api/v1/de-credit-note-pos";
    },
    totalNota() {
      return (this.form.details || []).reduce((t, d) => t + (parseFloat(d.total_amount) || 0), 0);
    },
  },
  methods: {
    renderItem(order) {
      this.order = order;
      // Sin facturación electrónica no hay notas de factura: todo es documento equivalente.
      this.electronica = !!order.is_electronic_invoice && this.$store.getters.getGeneralValue("gen_billing_invoice_electronically") == true;
      this.dialog = true;
      this.form = {
        details: [],
      };
      this.setRules();
      this.getDocumentEquivalent();
    },
    closeModal() {
      this.order = null;
      this.dialog = false;
      this.form = {};
    },
    async getDocumentEquivalent() {
      const invoice = await this.$http.get(
        this.electronica ? "api/v1/invoice-finalized" : "api/v1/equivalent-document-finalized",
        { consecutive_invoice: this.order.consecutive_order_text },
        true
      );
      if (invoice.success) {
        if (invoice.items && invoice.items.length > 0) {
          this.invoice = invoice.items[0];
          this.form.invoice = {
            id: this.invoice.id,
            name: this.invoice.consecutive_invoice,
          };
          this.form.electronica = this.electronica;
          this.form = JSON.parse(JSON.stringify(this.form));
        }else{
          this.closeModal();
          this.$store.commit('setError', this.electronica ? 'No se encontró la factura electrónica de esta orden, o ya fue reversada en su totalidad' : 'Esta orden ya fue reversada en su totalidad');
        }
      }
    },
    setRules() {
      this.rules = {
        credit_note_date: "required",
        invoice: "required",
        credit_note_discrepancy_responses: "required",
        observations: "required",
        details: "required",
      };
    },
    getValues() {
      let values = {};
      if (
        !this.item ||
        this.hasChanged(
          this.item["credit_note_date"],
          this.form["credit_note_date"]
        )
      ) {
        values["credit_note_date"] = this.form["credit_note_date"];
      }
      if (
        !this.item ||
        this.hasChanged(this.item["invoice"], this.form["invoice"])
      ) {
        values["invoice"] = this.form["invoice"]
          ? this.form["invoice"].id
          : null;
      }
      if (
        !this.item ||
        this.hasChanged(
          this.item["credit_note_discrepancy_responses"],
          this.form["credit_note_discrepancy_responses"]
        )
      ) {
        values["credit_note_discrepancy_responses"] = this.form[
          "credit_note_discrepancy_responses"
        ]
          ? this.form["credit_note_discrepancy_responses"].id
          : null;
      }
      if (
        !this.item ||
        this.hasChanged(this.item["observations"], this.form["observations"])
      ) {
        values["observations"] = this.form["observations"];
      }
      if (
        !this.item ||
        this.hasChanged(this.item["details"], this.form["details"])
      ) {
        values["details"] = this.form["details"];
      }
      // La devolución sale de la caja de hoy: va al turno abierto, no al de la orden (que puede estar
      // cerrado y cuadrado). Es lo mismo que hace la nota crédito creada desde el listado (MixinForm.js).
      const turno = this.$store.getters.turn;
      values["cash_register"] = turno ? turno.bill_cash_register_id : this.order.bill_cash_register_id;
      values["cash_register_turn"] = turno ? turno.id : this.order.bill_cash_register_turn_id;
      return values;
    },
    async executeCreate() {
      const values = this.getValues();
      const res = await this.$http.post(this.urlSave, values, true,true);
      if (res.success) {
        this.closeModal();
      }
    },
    saveRowItem(item) {
      //console.log('detail save row', item)
      for (let i in this.form.details) {
        if (this.form.details[i].id == item.id) {
          this.form.details[i] = item;
          return;
        }
      }
      this.addItemToDetails(item);
    },
    addItemToDetails(item) {
      if (!this.form["details"]) {
        this.form["details"] = [];
      }
      this.form["details"].push(item);
      // this.form = JSON.parse(JSON.stringify(this.form));
    },
  },
};
</script>